
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ExportModuleSyncStatus} from './ExportModuleSyncStatus';
import {FieldModelExportModuleSyncStatus} from './ExportModuleSyncStatus';

/**
 * ExportModuleSyncInfo struct
 */
class ExportModuleSyncInfo {
  /**
   * Initialize struct
   * @param {!ExportModuleSyncStatus=} syncStatus
   * @param {Date=} lastRecordTimestamp
   * @param {number=} lastRecordId
   * @param {string=} errorText
   * @constructor
   */
  constructor (syncStatus = new ExportModuleSyncStatus(), lastRecordTimestamp = null, lastRecordId = null, errorText = null) {
    this.SyncStatus = syncStatus
    this.LastRecordTimestamp = lastRecordTimestamp
    this.LastRecordId = lastRecordId
    this.ErrorText = errorText
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ExportModuleSyncInfo}
   * @param {!ExportModuleSyncInfo} other Other struct
   * @returns {!ExportModuleSyncInfo} This struct
   */
  copy (other) {
    if (other.SyncStatus != null) {
      this.SyncStatus = ExportModuleSyncStatus.fromObject(other.SyncStatus)
    } else {
      this.SyncStatus = null
    }
    if (other.LastRecordTimestamp != null) {
      if (other.LastRecordTimestamp instanceof Date) {
        this.LastRecordTimestamp = new Date(other.LastRecordTimestamp.getTime())
      } else {
        this.LastRecordTimestamp = new Date(Math.round(other.LastRecordTimestamp / 1000000))
      }
    } else {
      this.LastRecordTimestamp = null
    }
    if (other.LastRecordId != null) {
      this.LastRecordId = UInt64.fromNumber(other.LastRecordId)
    } else {
      this.LastRecordId = null
    }
    if (other.ErrorText != null) {
      this.ErrorText = other.ErrorText
    } else {
      this.ErrorText = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ExportModuleSyncInfo}
   * @returns {!ExportModuleSyncInfo} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ExportModuleSyncInfoModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ExportModuleSyncInfoModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ExportModuleSyncInfo}
   * @param {!ExportModuleSyncInfo} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ExportModuleSyncInfo)) {
      throw new TypeError('Instance of ExportModuleSyncInfo is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ExportModuleSyncInfo}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      SyncStatus: ((this.SyncStatus != null) ? this.SyncStatus : null),
      LastRecordTimestamp: ((this.LastRecordTimestamp != null) ? (this.LastRecordTimestamp.getTime() * 1000000) : null),
      LastRecordId: ((this.LastRecordId != null) ? this.LastRecordId.toNumber() : null),
      ErrorText: ((this.ErrorText != null) ? this.ErrorText : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ExportModuleSyncInfo.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ExportModuleSyncInfo} other Object value
   * @returns {!ExportModuleSyncInfo} Created struct
   */
  static fromObject (other) {
    return new ExportModuleSyncInfo().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ExportModuleSyncInfo}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ExportModuleSyncInfo.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ExportModuleSyncInfo}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 86
  }
}

export { ExportModuleSyncInfo };

/**
 * Fast Binary Encoding ExportModuleSyncInfo field model
 */
class FieldModelExportModuleSyncInfo extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.SyncStatus = new FieldModelExportModuleSyncStatus(buffer, 4 + 4)
    this.LastRecordTimestamp = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.SyncStatus.fbeOffset + this.SyncStatus.fbeSize), buffer, this.SyncStatus.fbeOffset + this.SyncStatus.fbeSize)
    this.LastRecordId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.LastRecordTimestamp.fbeOffset + this.LastRecordTimestamp.fbeSize), buffer, this.LastRecordTimestamp.fbeOffset + this.LastRecordTimestamp.fbeSize)
    this.ErrorText = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.LastRecordId.fbeOffset + this.LastRecordId.fbeSize), buffer, this.LastRecordId.fbeOffset + this.LastRecordId.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelExportModuleSyncInfo}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelExportModuleSyncInfo}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.SyncStatus.fbeSize + this.LastRecordTimestamp.fbeSize + this.LastRecordId.fbeSize + this.ErrorText.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelExportModuleSyncInfo}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.SyncStatus.fbeExtra + this.LastRecordTimestamp.fbeExtra + this.LastRecordId.fbeExtra + this.ErrorText.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelExportModuleSyncInfo}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelExportModuleSyncInfo.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelExportModuleSyncInfo}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 86
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelExportModuleSyncInfo}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelExportModuleSyncInfo}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.SyncStatus.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SyncStatus.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SyncStatus.fbeSize

    if ((fbeCurrentSize + this.LastRecordTimestamp.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastRecordTimestamp.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordTimestamp.fbeSize

    if ((fbeCurrentSize + this.LastRecordId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastRecordId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordId.fbeSize

    if ((fbeCurrentSize + this.ErrorText.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ErrorText.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ErrorText.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelExportModuleSyncInfo}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelExportModuleSyncInfo}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelExportModuleSyncInfo}
   * @param {!ExportModuleSyncInfo} fbeValue Default value, defaults is new ExportModuleSyncInfo()
   * @returns {!ExportModuleSyncInfo} ExportModuleSyncInfo value
   */
  get (fbeValue = new ExportModuleSyncInfo()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelExportModuleSyncInfo}
   * @param {!ExportModuleSyncInfo} fbeValue ExportModuleSyncInfo value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.SyncStatus.fbeSize) <= fbeStructSize) {
      fbeValue.SyncStatus = this.SyncStatus.get()
    } else {
      fbeValue.SyncStatus = new ExportModuleSyncStatus()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SyncStatus.fbeSize

    if ((fbeCurrentSize + this.LastRecordTimestamp.fbeSize) <= fbeStructSize) {
      fbeValue.LastRecordTimestamp = this.LastRecordTimestamp.get()
    } else {
      fbeValue.LastRecordTimestamp = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordTimestamp.fbeSize

    if ((fbeCurrentSize + this.LastRecordId.fbeSize) <= fbeStructSize) {
      fbeValue.LastRecordId = this.LastRecordId.get()
    } else {
      fbeValue.LastRecordId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordId.fbeSize

    if ((fbeCurrentSize + this.ErrorText.fbeSize) <= fbeStructSize) {
      fbeValue.ErrorText = this.ErrorText.get()
    } else {
      fbeValue.ErrorText = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ErrorText.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelExportModuleSyncInfo}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelExportModuleSyncInfo}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelExportModuleSyncInfo}
   * @param {!ExportModuleSyncInfo} fbeValue ExportModuleSyncInfo value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelExportModuleSyncInfo}
   * @param {ExportModuleSyncInfo} fbeValue ExportModuleSyncInfo value
   */
  setFields (fbeValue) {
    this.SyncStatus.set(fbeValue.SyncStatus)
    this.LastRecordTimestamp.set(fbeValue.LastRecordTimestamp)
    this.LastRecordId.set(fbeValue.LastRecordId)
    this.ErrorText.set(fbeValue.ErrorText)
  }
}

export { FieldModelExportModuleSyncInfo };

/**
 * Fast Binary Encoding ExportModuleSyncInfo model
 */
class ExportModuleSyncInfoModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelExportModuleSyncInfo(this.buffer, 4)
  }

  /**
   * Get the ExportModuleSyncInfo model
   * @this {!ExportModuleSyncInfoModel}
   * @returns {!FieldModelExportModuleSyncInfo} model ExportModuleSyncInfo model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ExportModuleSyncInfoModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ExportModuleSyncInfoModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ExportModuleSyncInfoModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ExportModuleSyncInfoModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelExportModuleSyncInfo.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ExportModuleSyncInfoModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ExportModuleSyncInfoModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ExportModuleSyncInfoModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ExportModuleSyncInfoModel}
   * @param {!ExportModuleSyncInfo} value ExportModuleSyncInfo value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ExportModuleSyncInfoModel}
   * @param {!ExportModuleSyncInfo} value ExportModuleSyncInfo value, defaults is new ExportModuleSyncInfo()
   * @return {!object} Deserialized ExportModuleSyncInfo value and its size
   */
  deserialize (value = new ExportModuleSyncInfo()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ExportModuleSyncInfo(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ExportModuleSyncInfo(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ExportModuleSyncInfoModel}
   * @param {!number} prev Previous ExportModuleSyncInfo model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ExportModuleSyncInfoModel };
